import React from 'react';
import { Text, StyleSheet } from '@react-pdf/renderer';

/**
 * MUI Titles section components that replace the styled-components Titles section
 * 
 * This file provides Material UI equivalents of the original Titles section components
 * with similar props and functionality. They're used for PDF generation.
 */

// Interface for common title props
interface TitleProps {
  content: string;
}

// Define styles for PDF titles
const styles = StyleSheet.create({
  headerSubTitle: {
    paddingTop: 5,
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 5,
    color: '#000',
  }, 
  title: {
    paddingTop: 14,
    alignItems: 'flex-end',
    fontSize: 18,
    fontWeight: 'bold',
  },
  subTitle: {
    paddingTop: 8,
    paddingBottom: 4,
    fontSize: 14,
    fontWeight: 'bold',
  },
});

/**
 * MuiHeaderSubTitle component
 * 
 * @param {TitleProps} props - Component props
 * @param {string} props.content - The content to display
 * @returns {JSX.Element} MUI HeaderSubTitle component
 */
export const MuiHeaderSubTitle: React.FC<TitleProps> = ({ content }) => (
  <Text style={styles.headerSubTitle}>{content}</Text>
);

/**
 * MuiTitle component
 * 
 * @param {TitleProps} props - Component props
 * @param {string} props.content - The content to display
 * @returns {JSX.Element} MUI Title component
 */
export const MuiTitle: React.FC<TitleProps> = ({ content }) => (
  <Text style={styles.title}>{content}</Text>
);

/**
 * MuiSubTitle component
 * 
 * @param {TitleProps} props - Component props
 * @param {string} props.content - The content to display
 * @returns {JSX.Element} MUI SubTitle component
 */
export const MuiSubTitle: React.FC<TitleProps> = ({ content }) => (
  <Text style={styles.subTitle}>{content}</Text>
);

export default {
  MuiHeaderSubTitle,
  MuiTitle,
  MuiSubTitle,
};
